<template>
  <div class="home">
    <!-- 新闻资讯 -->
    <div class="homeNewsBox">
      <div class="left">
        <el-carousel height="529px" direction="vertical" autoplay>
          <!-- 福州温泉博物馆 -->
          <el-carousel-item>
            <div class="leftTop">
              <div class="title">福州温泉博物馆</div>
              <div class="time">
                <div>9:00<br /><span>上午</span></div>
                <div>-</div>
                <div>12:00<br /><span>闭馆</span></div>

                <div style="margin-left: 8px">13:00<br /><span>下午</span></div>
                <div>-</div>
                <div>17:00<br /><span>闭馆</span></div>
              </div>
              <div class="close">
                周二至周日免费开放 (周一闭馆，国家法定节假日除外，其中11:30-12:00 16:30-17:00停止入馆)
              </div>
            </div>
            <div class="leftBottom">
              <div class="tp">
                <p>
                  <span class="label">地址</span>：
                  <span>鼓楼区温泉公园路8号福州温泉博物馆.</span>
                </p>
                <p>
                  <span class="label">公交路线</span>：
                  <span>乘坐49路、53路、177路公交车到福州温泉博物馆站下车</span>
                </p>
                <p>
                  <span class="label">预约微信</span>：
                  <span>鼓楼文体旅公众号</span>
                </p>
                <p>
                  <span class="label">咨询电话</span>：
                  <span>0591-63335000</span>
                </p>
                <p>
                  请携带有效身份证件,如身份证、学生证、港澳通行证、护照、老年证等入馆参观亦可通过扫描官微二维码预约参观
                </p>
              </div>
            </div></el-carousel-item
          >
          <!-- 福州古厝展示馆 -->
          <el-carousel-item>
            <div class="leftTop">
              <div class="title">福州古厝展示馆</div>
              <div class="time">
                <div>9:00<br /><span>上午</span></div>
                <div>-</div>
                <div>12:00<br /><span>闭馆</span></div>

                <div style="margin-left: 8px">13:30<br /><span>下午</span></div>
                <div>-</div>
                <div>17:00<br /><span>闭馆</span></div>
              </div>
              <div class="close">
                周二至周日免费开发（周一闭馆，国家法定节假日除外，其中11:30-12:00 16:30-17:00停止入馆）
              </div>
            </div>
            <div class="leftBottom">
              <div class="tp" style="line-height: 20px">
                <p>
                  <span class="label">地址</span>：
                  <span>福州市鼓楼区福飞南路139号屏山公园镇海楼景区内</span>
                </p>
                <p>
                  <span class="label">公交路线</span>：
                  <span
                    >乘坐9路、19路、54路、65路、129路、102路、111路、106路、78路、80路公交车在源脉温泉站下车</span
                  >
                </p>
                <p>
                  <span class="label">预约微信</span>：
                  <span>鼓楼文体旅公众号</span>
                </p>
                <p>
                  <span class="label">咨询电话</span>：
                  <span>0591-63335000</span>
                </p>
                <p>
                  请携带有效身份证件,如身份证、学生证、港澳通行证、护照、老年证等入馆参观亦可通过扫描官微二维码预约参观
                </p>
              </div>
            </div></el-carousel-item
          >

          <!-- 福州历史文化名城展示馆 -->
          <el-carousel-item>
            <div class="leftTop">
              <div class="title">福州历史文化名城展示馆</div>
              <div style="height: 15px"></div>
              <div class="other">周二~周五 上午9:00-12:00 下午13:30-18:00</div>
              <div class="close">（其中11:30-12:00 17:30~18:00停止入馆）</div>

              <div style="height: 15px"></div>
              <div class="other">
                周六~周日及法定节假日 上午9:00-12:00 下午13:30-21:00
              </div>
              <div class="close">（其中11:30-12:00 20:30~21:00停止入馆）</div>
            </div>
            <div class="leftBottom">
              <div class="tp" style="line-height: 20px">
                <p>
                  <span class="label">地址</span>：
                  <span>福州市鼓楼区福飞南路139号屏山公园镇海楼景区内</span>
                </p>
                <p>
                  <span class="label">公交路线</span>：
                  <span
                    >乘坐9路、19路、54路、65路、129路、102路、111路、106路、78路、80路公交车在源脉温泉站下车</span
                  >
                </p>
                <p>
                  <span class="label">预约微信</span>：
                  <span>鼓楼文体旅公众号</span>
                </p>
                <p>
                  <span class="label">咨询电话</span>：
                  <span>0591-63335000</span>
                </p>
                <p>
                  请携带有效身份证件,如身份证、学生证、港澳通行证、护照、老年证等入馆参观亦可通过扫描官微二维码预约参观
                </p>
              </div>
            </div></el-carousel-item
          >

          <!-- 镇海楼户外和中道至大平台 -->
          <el-carousel-item>
            <div class="leftTop">
              <div class="title">镇海楼户外和中道至大平台</div>
              <div class="time">
                <div>9:00<br /><span>开馆</span></div>
                <div>-</div>
                <div>20:30<br /><span>停止进馆</span></div>

                <div>-</div>
                <div>21:00<br /><span>闭馆</span></div>
              </div>
              <div class="close">
                周二至周日免费开放 (周一闭馆，国家法定节假日除外)
              </div>
            </div>
            <div class="leftBottom">
              <div class="tp" style="line-height: 20px">
                <p>
                  <span class="label">地址</span>：
                  <span>福州市鼓楼区福飞南路139号屏山公园镇海楼景区内</span>
                </p>
                <p>
                  <span class="label">公交路线</span>：
                  <span
                    >乘坐9路、19路、54路、65路、129路、102路、111路、106路、78路、80路公交车在源脉温泉站下车</span
                  >
                </p>
                <p>
                  <span class="label">预约微信</span>：
                  <span>鼓楼文体旅公众号</span>
                </p>
                <p>
                  <span class="label">咨询电话</span>：
                  <span>0591-63335000</span>
                </p>
                <p>
                  请携带有效身份证件,如身份证、学生证、港澳通行证、护照、老年证等入馆参观亦可通过扫描官微二维码预约参观
                </p>
              </div>
            </div></el-carousel-item
          >

          <!-- 林纾故居 -->
          <el-carousel-item>
            <div class="leftTop">
              <div class="title">林纾故居</div>
              <div class="time">
                <div>9:00<br /><span>上午</span></div>
                <div>-</div>
                <div>12:00<br /><span>闭馆</span></div>

                <div style="margin-left: 8px">13:00<br /><span>下午</span></div>
                <div>-</div>
                <div>17:00<br /><span>闭馆</span></div>
              </div>
              <div class="close">
                周二至周日免费开放 (周一闭馆，国家法定节假日除外，其中11:30-12:00 16:30-17:00停止入馆)
              </div>
            </div>
            <div class="leftBottom">
              <div class="tp" style="line-height: 18px">
                <p>
                  <span class="label">地址</span>：
                  <span>福州市鼓楼区六一中路40号莲宅村内</span>
                </p>
                <p>
                  <span class="label">公交路线</span>：
                  <span
                    >乘坐73路、69路、80路、125路、92路、318路、306路、71路、88路、129路、79路、103路、74路、16路、7路公交车到古田六一路口站下车</span
                  >
                </p>
                <p>
                  <span class="label">预约微信</span>：
                  <span>鼓楼文体旅公众号</span>
                </p>
                <p>
                  <span class="label">咨询电话</span>：
                  <span>0591-63335000</span>
                </p>
                <p>
                  请携带有效身份证件,如身份证、学生证、港澳通行证、护照、老年证等入馆参观亦可通过扫描官微二维码预约参观
                </p>
              </div>
            </div></el-carousel-item
          >

          <!-- 高士其故居 -->
          <el-carousel-item>
            <div class="leftTop">
              <div class="title">高士其故居</div>
              <div class="time">
                <div>9:00<br /><span>上午</span></div>
                <div>-</div>
                <div>12:00<br /><span>闭馆</span></div>

                <div style="margin-left: 8px">13:00<br /><span>下午</span></div>
                <div>-</div>
                <div>17:00<br /><span>闭馆</span></div>
              </div>
              <div class="close">
                周二至周日免费开放 (周一闭馆，国家法定节假日除外，其中11:30-12:00 16:30-17:00停止入馆)
              </div>
            </div>
            <div class="leftBottom">
              <div class="tp" style="line-height: 18px">
                <p>
                  <span class="label">地址</span>：
                  <span>福州市鼓楼区鳌峰坊3号</span>
                </p>
                <p>
                  <span class="label">公交路线</span>：
                  <span
                    >乘坐74路、76路、133路、2路、86路、69路、122路、80路、129路、106路、19路、130路、301路、52路、51路、60路、303路、64路公交车到龙华天桥站下车</span
                  >
                </p>
                <p>
                  <span class="label">预约微信</span>：
                  <span>鼓楼文体旅公众号</span>
                </p>
                <p>
                  <span class="label">咨询电话</span>：
                  <span>0591-63335000</span>
                </p>
                <p>
                  请携带有效身份证件,如身份证、学生证、港澳通行证、护照、老年证等入馆参观亦可通过扫描官微二维码预约参观
                </p>
              </div>
            </div></el-carousel-item
          >

          <!-- 方声洞故居 -->
          <el-carousel-item>
            <div class="leftTop">
              <div class="title">方声洞故居</div>
              <div class="time">
                <div>9:00<br /><span>上午</span></div>
                <div>-</div>
                <div>12:00<br /><span>闭馆</span></div>

                <div style="margin-left: 8px">13:00<br /><span>下午</span></div>
                <div>-</div>
                <div>17:00<br /><span>闭馆</span></div>
              </div>
              <div class="close">
                周二至周日免费开放 (周一闭馆，国家法定节假日除外，其中11:30-12:00 16:30-17:00停止入馆)
              </div>
            </div>
            <div class="leftBottom">
              <div class="tp">
                <p>
                  <span class="label">地址</span>：
                  <span>福州市鼓楼区外九彩巷与鼓屏路交叉口西南180米</span>
                </p>
                <p>
                  <span class="label">公交路线</span>：
                  <span
                    >乘坐54路、65路、66路、80路、111路公交车到省物价局站下车</span
                  >
                </p>
                <p>
                  <span class="label">预约微信</span>：
                  <span>鼓楼文体旅公众号</span>
                </p>
                <p>
                  <span class="label">咨询电话</span>：
                  <span>0591-63335000</span>
                </p>
                <p>
                  请携带有效身份证件,如身份证、学生证、港澳通行证、护照、老年证等入馆参观亦可通过扫描官微二维码预约参观
                </p>
              </div>
            </div></el-carousel-item
          >

          <!-- 泉山仁寿堂 -->
          <el-carousel-item>
            <div class="leftTop">
              <div class="title">
                泉山仁寿堂<span style="font-size: 16px">（含冶山清风苑）</span>
              </div>
              <div class="time">
                <div>9:00<br /><span>上午</span></div>
                <div>-</div>
                <div>12:00<br /><span>闭馆</span></div>

                <div style="margin-left: 8px">13:00<br /><span>下午</span></div>
                <div>-</div>
                <div>17:00<br /><span>闭馆</span></div>
              </div>
              <div class="close">
                周二至周日免费开放 (周一闭馆，国家法定节假日除外，其中11:30-12:00 16:30-17:00停止入馆)
              </div>
            </div>
            <div class="leftBottom">
              <div class="tp">
                <p>
                  <span class="label">地址</span>：
                  <span>福州市鼓楼区冶山路33号(屏山地铁站D口步行270米)</span>
                </p>
                <p>
                  <span class="label">公交路线</span>：
                  <span
                    >乘坐159路公交成到省林业局站下车或乘地铁1号线屏山地铁站D口</span
                  >
                </p>
                <p>
                  <span class="label">预约微信</span>：
                  <span>鼓楼文体旅公众号</span>
                </p>
                <p>
                  <span class="label">咨询电话</span>：
                  <span>0591-63335000</span>
                </p>
                <p>
                  请携带有效身份证件,如身份证、学生证、港澳通行证、护照、老年证等入馆参观亦可通过扫描官微二维码预约参观
                </p>
              </div>
            </div></el-carousel-item
          >

          <!-- 冶山春秋博物馆 -->
          <el-carousel-item>
            <div class="leftTop">
              <div class="title">冶山春秋博物馆</div>
              <div class="time">
                <div>9:00<br /><span>上午</span></div>
                <div>-</div>
                <div>12:00<br /><span>闭馆</span></div>

                <div style="margin-left: 8px">13:00<br /><span>下午</span></div>
                <div>-</div>
                <div>17:00<br /><span>闭馆</span></div>
              </div>
              <div class="close">
                周二至周日免费开放 (周一闭馆，国家法定节假日除外，其中11:30-12:00 16:30-17:00停止入馆)
              </div>
            </div>
            <div class="leftBottom">
              <div class="tp" style="line-height: 20px">
                <p>
                  <span class="label">地址</span>：
                  <span>福州市鼓楼区能补天巷29号</span>
                </p>
                <p>
                  <span class="label">公交路线</span>：
                  <span
                    >乘坐159路公交车到省林业局站下车或乘坐地铁1号线屏山地铁站D口</span
                  >
                </p>
                <p>
                  <span class="label">预约微信</span>：
                  <span>鼓楼文体旅公众号</span>
                </p>
                <p>
                  <span class="label">咨询电话</span>：
                  <span>0591-63335000</span>
                </p>
                <p>
                  请携带有效身份证件,如身份证、学生证、港澳通行证、护照、老年证等入馆参观亦可通过扫描官微二维码预约参观
                </p>
              </div>
            </div></el-carousel-item
          >
        </el-carousel>

        <div class="leftBottom" style="border-top: 1px solid #e8e8e8">
          <div class="bt">
            <div class="item" @click="toService">
              <div class="img">
                <img src="../assets/img/mapIcon.png" alt="" />
              </div>
              <span>地图导航</span>
            </div>
            <div class="item" @click="toService">
              <div class="img">
                <img src="../assets/img/smLoveIcon.png" alt="" />
              </div>
              <span>服务中心</span>
            </div>
            <div class="item" @click="openCode">
              <div class="img">
                <img src="../assets/img/timeIcon.png" alt="" />
              </div>
              <span>票务预约</span>
            </div>
            <div class="item" @click="ToVolunteer">
              <div class="img">
                <img src="../assets/img/lgLoveIcon.png" alt="" />
              </div>
              <span>志愿者</span>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="tabTop">
          <div class="tab" v-if="newTab && newTab.length > 0">
            <div
              class="item"
              v-for="(items, indexs) in newTab"
              :key="indexs"
              :class="{ active: newIndex == indexs }"
              @click="newTabFun(items.uiMenuId, indexs)"
            >
              {{ items.menuName }}
            </div>
          </div>
          <div class="more" @click="toNews">更多</div>
        </div>
        <div class="newItemBox" v-if="newTab && newTab.length > 0">
          <div
            class="newItem"
            v-for="(newItem, newIndex) in newData"
            :key="newIndex"
            @click="toInformationDetailFun(newItem)"
          >
            <div class="newTime" v-if="newItem.indexTime">
              <p class="bigSize">
                {{
                  newItem.indexTime.split("-")[2].split(" ")[0].split("T00")[0]
                }}
              </p>
              <p>
                {{
                  newItem.indexTime.split("-")[0] +
                  "." +
                  newItem.indexTime.split("-")[1]
                }}
              </p>
            </div>
            <div class="newBody">
              <div class="img">
                <img :src="ipPage + newItem.surfacePlot" alt="" />
              </div>
              <div class="riBox">
                <div class="title">{{ newItem.articleTitle }}</div>
                <div class="txt">{{ newItem.introduction }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 常设展览 -->
    <div class="allTitle">
      <div class="zh">陈列展厅</div>
      <div class="cn">EXCELLENT COLLECTION</div>
    </div>
    <div class="homeExhibitionBack">
      <div
        class="homeExhibitionBox"
        v-if="zhanlanData && zhanlanData.length > 0"
      >
        <div class="exhibitionLeft">
          <img
            :src="ipPage + zhanlanData[showZhanlanIndex].surfacePlot"
            alt=""
            class="backImg"
          />
          <div class="smallImgBox">
            <div
              class="img"
              :class="{ active: showZhanlanIndex == indexs }"
              v-for="(items, indexs) in zhanlanData"
              :key="indexs"
              @click="showZhanlanIndex = indexs"
            >
              <img :src="ipPage + items.surfacePlot" alt="" />
            </div>
          </div>
          <div
            class="detailBox"
            @click="goExhibitionFun(zhanlanData[showZhanlanIndex].articleId)"
          >
            进入<br />详情
          </div>
        </div>
        <div class="exhibitionRight">
          <div class="title">
            {{ zhanlanData[showZhanlanIndex].articleTitle }}
          </div>
          <div class="ch">THE LIGHT OF JING'AN CIVLIZATION</div>
          <div class="txt">{{ zhanlanData[showZhanlanIndex].location }}</div>
        </div>
      </div>
    </div>
    <!-- 馆藏精品 -->
    <div class="allTitle">
      <div class="zh">馆藏精品</div>
      <div class="cn">EXCELLENT COLLECTION</div>
    </div>
    <div class="homeCollectionBack">
      <iframe style="width: 1500px; margin: 0 auto; margin-top: 50px; height: 850px;"src="http://www.glqmuseum.com:9600/premium" frameborder="0"></iframe>
    </div>
    <!-- <div class="homeCollectionBack">
      <div
        class="collectionTab"
        v-if="collectionTab && collectionTab.length > 0"
      >
        <div
          class="tabItem"
          :class="{ active: collectionIndex == hxIndexs }"
          v-for="(hxItem, hxIndexs) in collectionTab"
          :key="hxIndexs"
          @click="collectionTabFun(hxItem.uiMenuId, hxIndexs)"
        >
          {{ hxItem && hxItem.menuName ? hxItem.menuName : "" }}
        </div>
      </div>
      <div class="collectionItemBox">
        <div
          class="collectionItem"
          v-for="(items, indexs) in collectionData"
          :key="indexs"
          @click="ToCollectionDetail(items.articleId)"
        >
          <div class="img">
            <img :src="ipPage + items.surfacePlot" alt="" />
          </div>
          <div class="title">{{ items.articleTitle }}</div>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
import { articleListApi, menuListApi } from "../assets/js/api";
export default {
  name: "home", //首页
  data() {
    return {
      index: 0,
      ipPage: sessionStorage.getItem("ips") || "",
      tabIndex: 0,
      parentId: "",
      zhanlanTab: [] /** 展览菜单 */,
      zhanlanData: [] /** 展览数据 */,
      showZhanlanIndex: 0 /** 展览当前展示的项 */,
      newTab: [] /** 资讯菜单 */,
      newData: [] /** 资讯数据 */,
      newIndex: 0 /** 资讯当前展示的项 */,
      collectionTab: [] /** 藏品菜单 */,
      collectionData: [] /** 藏品数据 */,
      collectionIndex: 0 /** 藏品当前展示的项 */,
    };
  },
  created() {
    this.getPageDataFun();
  },
  methods: {
    /** 获取页面数据 */
    getPageDataFun() {
      /**获取资讯菜单 */
      menuListApi({ parentId: 111 }).then((data) => {
        if (data.code === 200 && data.rows && data.rows.length > 0) {
          this.newTab = [data.rows[0], data.rows[1], data.rows[2]];
          /** 默认 */
          articleListApi({ articleType: this.newTab[0].uiMenuId }).then(
            (datas) => {
              this.newData = datas.rows.slice(0, 4);
            }
          );
        }
      });
      /** 获取展览菜单 */
      menuListApi({ parentId: 127 }).then((data) => {
        if (data.code === 200 && data.rows && data.rows.length > 0) {
          this.zhanlanTab = [data.rows[0]];
          /** 默认 */
          articleListApi({ articleType: this.zhanlanTab[0].uiMenuId }).then(
            (datas) => {
              this.zhanlanData = datas.rows.slice(0, 3);
            }
          );
        }
      });
      /** 获取藏品菜单 */
      menuListApi({ parentId: 126 }).then((data) => {
        if (data.code === 200 && data.rows && data.rows.length > 0) {
          this.collectionTab = [data.rows[0], data.rows[1], data.rows[2]];
          /** 默认 */
          articleListApi({ articleType: this.collectionTab[0].uiMenuId }).then(
            (datas) => {
              this.collectionData = datas.rows.slice(0, 6);
            }
          );
        }
      });
    },
    /** 跳转服务中心 */
    toMapNavigation() {
      sessionStorage.removeItem("detail_obj");
      sessionStorage.setItem(
        "ActiveObj",
        JSON.stringify({
          path: "huaianMuseumSummary",
          active: 159,
          activeName: ["服务指南", "huaianMuseumSummary"],
        })
      );
      this.$router.push("/common/128/huaianMuseumSummary");
    },
    /** 跳转服务中心 */
    toService() {
      sessionStorage.removeItem("detail_obj");
      sessionStorage.setItem(
        "ActiveObj",
        JSON.stringify({
          path: "huaianMuseumSummary",
          active: 130,
          activeName: ["服务指南", "huaianMuseumSummary"],
        })
      );
      this.$router.push("/common/128/huaianMuseumSummary");
    },
    /** 跳转教育活动 */
    Toeducation() {
      sessionStorage.removeItem("detail_obj");
      sessionStorage.setItem(
        "ActiveObj",
        JSON.stringify({
          path: "educationList",
          active: 51,
          activeName: ["教育活动", "pedagogicalActivity"],
        })
      );
      this.$router.push("/common/21/educationList");
    },
    /** 跳转志愿者 */
    ToVolunteer() {
      sessionStorage.removeItem("detail_obj");
      sessionStorage.setItem(
        "ActiveObj",
        JSON.stringify({
          path: "informationList",
          active: 154,
          activeName: ["志愿者", "informationList"],
        })
      );
      this.$router.push("/common/17/informationList");
    },
    /** 点击预约 */
    openCode() {
      this.$message({
        showClose: true,
        message: "暂无预约内容！",
      });
    },
    /** 点击新闻菜单切换 */
    newTabFun(id, index) {
      this.newIndex = index;
      articleListApi({ articleType: id }).then((data) => {
        this.newData = data.rows.slice(0, 4);
      });
    },
    /**新闻详情*/
    toInformationDetailFun(item) {
      console.log("this.newTab[this.newIndex]", this.newTab[this.newIndex]);
      let { parentId, uiMenuId, menuName, modulesType, menuEnName } =
        this.newTab[this.newIndex];
      console.log("this.newTab[this.newIndex]", this.newTab[this.newIndex]);
      sessionStorage.setItem(
        "detail_obj",
        JSON.stringify({ path: "informationDetail", id: item.articleId })
      );
      sessionStorage.setItem(
        "ActiveObj",
        JSON.stringify({
          path: modulesType,
          active: uiMenuId,
          activeName: [menuName, menuEnName],
        })
      );
      if (item.articleContentExternalLink) {
        return window.open(item.articleContentExternalLink);
      }
      this.$router.push({ path: `/common/${parentId}/informationDetail` });
    },
    /** 跳转新闻动态页面 */
    toNews() {
      sessionStorage.removeItem("detail_obj");
      sessionStorage.setItem(
        "ActiveObj",
        JSON.stringify({
          path: "informationList",
          active: 112,
          activeName: ["新闻动态", "news"],
        })
      );
      this.$router.push("/common/111/informationList");
    },
    /** 跳转展览详情 */
    goExhibitionFun(id) {
      let { parentId, uiMenuId, menuName, modulesType, menuEnName } =
        this.zhanlanTab[this.collectionIndex];
      sessionStorage.setItem(
        "detail_obj",
        JSON.stringify({ path: "exhibitionListDetail", id: id })
      );
      sessionStorage.setItem(
        "ActiveObj",
        JSON.stringify({
          path: modulesType,
          active: uiMenuId,
          activeName: [menuName, menuEnName],
        })
      );
      this.$router.push({ path: `/common/${parentId}/exhibitionListDetail` });
    },
    /** 藏品tab切换 */
    collectionTabFun(id, index) {
      this.collectionIndex = index;
      articleListApi({ articleType: id }).then((data) => {
        this.collectionData = data.rows.slice(0, 6);
      });
    },
    /** 跳转藏品详情 */
    ToCollectionDetail(id) {
      let { parentId, uiMenuId, menuName, modulesType, menuEnName } =
        this.collectionTab[this.collectionIndex];
      sessionStorage.setItem(
        "detail_obj",
        JSON.stringify({ path: "collectionDetail", id: id })
      );
      sessionStorage.setItem(
        "ActiveObj",
        JSON.stringify({
          path: modulesType,
          active: uiMenuId,
          activeName: [menuName, menuEnName],
        })
      );
      this.$router.push({ path: `/common/${parentId}/collectionDetail` });
    },
  },
};
</script>
<style lang="scss" scoped>
.el-message-box__message p {
  font-size: 18px;
}
</style>
<style lang="scss" scoped>
.allTitle {
  width: 192px;
  margin: 0 auto;
  .zh {
    font-size: 32px;
    color: #333333;
  }
  .cn {
    font-size: 16px;
    color: #c3c0bb;
    margin-top: 20px;
    &::after {
      content: "";
      display: block;
      width: 35px;
      height: 4px;
      background: #a99279;
      margin-top: 20px;
    }
  }
}
// 新闻资讯
.homeNewsBox {
  width: 1400px;
  margin: 82px auto;
  display: flex;
  .left {
    width: 550px;
    color: #fff;
    background-image: url(../assets/img/leftbg.png);
    .leftTop {
      height: 302px;
      padding: 35px 45px 39px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      .other {
        font-size: 17px;
        text-align: center;
      }
      // background-color: #a99279;
      // background-image: url(../assets/img/beginBack.png);
      // background-repeat: no-repeat;
      // background-size: contain;
      // background-position: center;
      .title {
        font-size: 32px;
        font-family: Microsoft YaHei;
        text-align: center;
        opacity: 0.8;
      }
      .time {
        font-size: 34px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        display: flex;
        line-height: 30px;
        div {
          margin: 6px;
          &:nth-last-child(1) {
            margin-right: 0;
          }
        }
        span {
          font-size: 18px;
          font-weight: 400;
          opacity: 0.8;
        }
      }
      .close {
        border-top: 1px solid rgba(232, 232, 232, 0.5);
        border-bottom: 1px solid rgba(232, 232, 232, 0.5);
        padding: 13px 0;
        text-align: center;
        opacity: 0.8;
      }
    }
    .leftBottom {
      // background-color: #b48f5d;
      // background-image: url(../assets/img/addressBack.png);
      // background-repeat: no-repeat;
      // background-size: contain;
      // background-position: center;
      font-size: 14px;
      .tp {
        padding: 15px 21px 0;
        line-height: 22px;

        p {
          margin: 0 0 15px;
          display: flex;
          .label {
            white-space: nowrap;
          }
          &::before {
            content: "";
            display: inline-block;
            width: 7px;
            height: 7px;
            border: 2px solid #ffffff;
            border-radius: 50%;
            margin-right: 7px;
            margin-top: 4px;
          }
          span {
            &.label {
              width: 65px;
              display: inline-block;
              text-align: justify;
              text-align-last: justify;
              font-weight: 400;
            }
          }
          &:nth-last-child(1)::before {
            display: none;
          }
        }
      }
      .bt {
        display: flex;
        padding: 10px 0;
        .item {
          flex: 1;
          text-align: center;
          cursor: pointer;
          &:hover {
            img {
              transform: scale(1.2);
            }
          }
          .img {
            width: 35px;
            height: 37px;
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: center;
            overflow: hidden;
            img {
              transition: all 0.4s;
            }
          }
          span {
            display: block;
          }
        }
      }
    }
  }
  .right {
    flex: 1;
    padding-left: 40px;
    box-sizing: border-box;
    min-width: 0;
    .tabTop {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #d7d7d7;
      .tab {
        display: flex;
        .item {
          padding: 17px 14px;
          cursor: pointer;
          margin-right: 22px;
          font-size: 18px;
          &.active {
            color: #ffffff;
            background: #a99279;
          }
          &:hover {
            color: #ffffff;
            background: #a99279;
          }
        }
      }
      .more {
        font-size: 13px;
        color: #ffffff;
        width: 61px;
        height: 31px;
        line-height: 31px;
        text-align: center;
        cursor: pointer;
        background-image: url(../assets/img/newMore.png);
        background-size: cover;
        background-repeat: no-repeat;
        &:hover {
          font-size: 14px;
        }
      }
    }
    .newItemBox {
      .newItem {
        display: flex;
        align-items: center;
        padding: 19px 0;
        border-bottom: 1px solid #e8e8e8;
        &:nth-last-child(1) {
          border-bottom: none;
        }
        .newTime {
          width: 68px;
          height: 68px;
          border: 1px solid #a99279;
          border-radius: 4px;
          color: #a99279;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          font-size: 14px;
          p {
            margin: 0;
          }
          .bigSize {
            font-size: 26px;
          }
        }
        .newBody {
          flex: 1;
          padding-left: 28px;
          display: flex;
          cursor: pointer;
          min-width: 0;
          .img {
            width: 147px;
            height: 87px;
            img {
              width: 147px;
              height: 87px;
            }
          }
          .riBox {
            padding-left: 24px;
            min-width: 0;
            .title {
              font-size: 18px;
              color: #333333;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              margin-bottom: 15px;
              &:hover {
                color: #a99279;
              }
            }
            .txt {
              font-size: 14px;
              color: #999999;
              line-height: 24px;
              display: box;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              line-clamp: 2;
              -webkit-line-clamp: 2;
              overflow: hidden;
              text-overflow: ellipsis;
              &:hover {
                color: #a99279;
              }
            }
          }
        }
      }
    }
  }
}

// 常设展览
.homeExhibitionBack {
  background-image: url(../assets/img/exhibitionBack.png);
  background-size: cover;
  background-repeat: no-repeat;
  padding: 10px 0;
  margin: 49px 0 74px;
  .homeExhibitionBox {
    width: 1400px;
    height: 635px;
    margin: 0 auto;
    display: flex;
    .exhibitionLeft {
      flex: 1;
      height: 100%;
      position: relative;
      .backImg {
        width: 100%;
        height: 100%;
      }
      .smallImgBox {
        position: absolute;
        left: 64px;
        bottom: 57px;
        display: flex;
        .img {
          height: 82px;
          width: 82px;
          margin-right: 60px;
          border-radius: 50%;
          overflow: hidden;
          border: 2px solid #ffffff;
          cursor: pointer;
          &.active {
            border: 2px solid #a99279;
          }
          &:nth-last-child(1) {
            margin-right: 0;
          }
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .detailBox {
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 22px;
        position: absolute;
        right: 15px;
        bottom: 24px;
        width: 97px;
        height: 98px;
        background-image: url(../assets/img/exhibitionDetilBack.png);
        background-size: cover;
        background-repeat: no-repeat;
        cursor: pointer;
      }
    }
    .exhibitionRight {
      width: 447px;
      height: 100%;
      padding: 54px 23px 0;
      box-sizing: border-box;
      background-image: url(../assets/img/exhibitionRightBack.png);
      background-size: cover;
      background-repeat: no-repeat;
      .title {
        font-size: 24px;
        color: #ffffff;
        margin-bottom: 14px;
        text-align: center;
      }
      .ch {
        font-size: 12px;
        color: #cbb5b6;
        margin-bottom: 50px;
        text-align: center;
      }
      .txt {
        font-size: 14px;
        color: #ffffff;
        text-indent: 2em;
        line-height: 30px;
      }
    }
  }
}
/** 馆藏精品 */
.homeCollectionBack {
  width: 1400px;
  margin: 0 auto;
  position: relative;
  .collectionTab {
    border-bottom: 1px solid #e2e8f2;
    padding: 0 70px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    margin-top: 53px;
    .tabItem {
      padding: 0 15px 14px;
      border-bottom: 2px solid transparent;
      margin: 0 10px;
      cursor: pointer;
      &.active {
        color: #a99279;
        border-bottom: 2px solid #a99279;
      }
    }
  }
  .collectionItemBox {
    display: flex;
    flex-wrap: wrap;
    padding-top: 150px;
    margin-bottom: 50px;
    min-height: 10px;
    .collectionItem {
      width: calc(100% / 3 - 14px);
      margin-right: 21px;
      margin-bottom: 21px;
      cursor: pointer;
      &:nth-child(3n) {
        margin-right: 0;
      }
      &:hover {
        .title {
          background-color: #a99279;
          color: #ffffff;
        }
      }
      .img {
        img {
          width: 100%;
          height: 264px;
          object-fit: cover;
          vertical-align: bottom;
        }
      }
      .title {
        padding: 19px 0;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        background-color: #f5f6f7;
        transition: all 0.3s;
      }
    }
  }
}
.mb10 {
  margin-bottom: 10px !important;
}
.mb15 {
  margin-bottom: 15px !important;
}
.mb20 {
  margin-bottom: 20px !important;
}
.mb25 {
  margin-bottom: 25px !important;
}
.mb30 {
  margin-bottom: 30px !important;
}
.mb40 {
  margin-bottom: 40px !important;
}
.mr10 {
  margin-right: 10px !important;
}
.mr15 {
  margin-right: 15px !important;
}
.mr20 {
  margin-right: 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/home.vue